// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================

/**
 * Task creation type
 */
export enum ECpmCTaskTypeApiEnum {
    GROUP = 'GROUP',
    SIMPLE = 'SIMPLE',
    SMART = 'SMART'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCTaskTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCTaskTypeApiEnum).map(([key, value]) => [value, key as ECpmCTaskTypeApiEnum])
);

// ===============================================================
// ===============================================================

/**
 * Task status
 */
export enum ECpmCTaskStatusApiEnum {
    CREATED = 'CREATED',
    READY = 'READY',
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCTaskStatusApiEnum = Object.fromEntries(
    Object.entries(ECpmCTaskStatusApiEnum).map(([key, value]) => [value, key as ECpmCTaskStatusApiEnum])
);

// ===============================================================
// ===============================================================

/**
 * Task attributes 1
 */
export enum ECpmCTaskAttributes1ApiEnum {
    NONE = 0,
    GROUP_AUTO_EXPAND = 1 << 6,
    SIMPLE_IS_MILESTONE = 1 << 7,
    SMART_REQUIRES_MANUAL_INPUT = 1 << 8,
    OUTDATED = 1 << 9,
    LAST_EXECUTION_FAILED = 1 << 10,

    MASK_GROUP_ALLOWED_ATTRIBUTES1 = GROUP_AUTO_EXPAND | OUTDATED | LAST_EXECUTION_FAILED,
    MASK_SIMPLE_ALLOWED_ATTRIBUTES1 = SIMPLE_IS_MILESTONE | OUTDATED | LAST_EXECUTION_FAILED,
    MASK_SMART_ALLOWED_ATTRIBUTES1 = SMART_REQUIRES_MANUAL_INPUT | OUTDATED | LAST_EXECUTION_FAILED
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCTaskAttributes1ApiEnum = Object.fromEntries(
    Object.entries(ECpmCTaskAttributes1ApiEnum)
        .filter((x) => !x[0].toString().toUpperCase().startsWith('MASK_'))
        .filter((x) => !x[1].toString().toUpperCase().startsWith('MASK_'))
        .map(([key, value]) => [value, key as unknown as ECpmCTaskAttributes1ApiEnum])
);
